<div class="clock-component" [ngClass]="{ 'dx-rtl': rtlEnabled }" dir="{{rtlEnabled ? 'rtl' : 'ltr'}}">
  <dx-popup #addClock [width]="850" [showTitle]="true" title="{{ modalTitle }}" [dragEnabled]="false"
            [closeOnOutsideClick]="false" [rtlEnabled]="rtlEnabled" [(visible)]="isOpened"
            (onShown)="onFieldDataChanged($event)">
    <dx-scroll-view width="100%" height="100%" *ngIf="isOpened">

      <dx-form #clockForm id="clockForm" [showValidationSummary]="false"
               (onFieldDataChanged)="onFieldDataChanged($event)"
               colCount="auto" [(formData)]="model" [minColWidth]="500">
        <dxi-item itemType="tabbed">
          <dxi-tab title="{{ 'SHARED.MODE' | translate }}">
            <dxi-item itemType="group">

              <dxi-item dataField="name">
                <dxo-label text="{{ 'SHARED.NAME' | translate }}"></dxo-label>
                <dxi-validation-rule type="required" message="{{ 'SHARED.NAME' | translate }} {{ 'SHARED.IS_REQUIRED' | translate }}">
                </dxi-validation-rule>
              </dxi-item>

              <dxi-item dataField="auctionId" editorType="dxSelectBox"
                        [editorOptions]="{disabled: isEditMode, items: auctions, valueExpr:'auctionId', displayExpr:'name'}">
                <dxo-label text="{{ 'SHARED.AUCTION' | translate }}"></dxo-label>
                <dxi-validation-rule type="required" message="{{ 'SHARED.AUCTION' | translate }} {{ 'SHARED.IS_REQUIRED' | translate }}">
                </dxi-validation-rule>
              </dxi-item>

              <dxi-item dataField="catalogId" editorType="dxSelectBox"
                        [editorOptions]="{ items: filteredCatalogs, valueExpr:'catalogId', displayExpr:'name'}">
                <dxo-label text="{{ 'SHARED.CATALOG' | translate }}"></dxo-label>
                <dxi-validation-rule type="required" message="{{ 'SHARED.CATALOG' | translate }} {{ 'SHARED.IS_REQUIRED' | translate }}">
                </dxi-validation-rule>
              </dxi-item>

              <dxi-item dataField="mode.mode" editorType="dxSelectBox"
                        [editorOptions]="{ items: modes, valueExpr:'value', displayExpr: translateSelectBoxes }">
                <dxo-label text="{{ 'SHARED.MODE' | translate }}"></dxo-label>
                <dxi-validation-rule type="required" message="{{ 'SHARED.MODE' | translate }} {{ 'SHARED.IS_REQUIRED' | translate }}">
                </dxi-validation-rule>
              </dxi-item>

              <dxi-item itemType="group" [visible]="(model.mode.mode === 1 || model.mode.mode === 4 || model.mode.mode === 6)">
                <dxi-item dataField="mode.clockStep" editorType="dxNumberBox">
                  <dxo-label text="{{ 'CLOCK.CLOCKSTEP' | translate }}"></dxo-label>
                </dxi-item>

                <dxi-item dataField="mode.clockSpeed" editorType="dxNumberBox">
                  <dxo-label text="{{ 'CLOCK.CLOCKSPEED' | translate }}"></dxo-label>
                </dxi-item>
              </dxi-item>

              <dxi-item itemType="group" [visible]="(model.mode.mode === 3 || model.mode.mode === 4)">
                <dxi-item dataField="mode.clockStepUp" editorType="dxNumberBox">
                  <dxo-label text="{{ 'CLOCK.CLOCKSTEP_UP' | translate }}"></dxo-label>
                </dxi-item>

                <dxi-item dataField="mode.clockSpeedUp" editorType="dxNumberBox">
                  <dxo-label text="{{ 'CLOCK.CLOCKSPEED_UP' | translate }}"></dxo-label>
                </dxi-item>
              </dxi-item>

              <dxi-item dataField="mode.coinCodeMasterDataListRowId" editorType="dxSelectBox"
                        [editorOptions]="{ items: coinCodeModes, valueExpr:'masterDataListRowId', displayExpr: 'displayValue' }">
                <dxo-label text="{{ 'CLOCK.COINCODES' | translate }}"></dxo-label>
                <dxi-validation-rule type="required" message="{{ 'SHARED.MODE' | translate }} {{ 'SHARED.IS_REQUIRED' | translate }}">
                </dxi-validation-rule>
              </dxi-item>

              <dxi-item itemType="group" [visible]="(model.mode.mode === 1)">
                <dxi-item dataField="mode.snap" editorType="dxNumberBox">
                  <dxo-label text="{{ 'CLOCK.SNAP' | translate }}"></dxo-label>
                </dxi-item>
              </dxi-item>

              <dxi-item itemType="group" [visible]="(model.mode.mode === 1 || model.mode.mode === 4 || model.mode.mode === 6)" *ngIf="user.isSystemUser">
                <dxi-item dataField="mode.minimumPriceSteps" editorType="dxNumberBox">
                  <dxo-label text="{{ 'CLOCK.MINIMUM_PRICE' | translate }}"></dxo-label>
                </dxi-item>

                <dxi-item dataField="mode.clockStepsAfterMinimumPrice" editorType="dxNumberBox">
                  <dxo-label text="{{ 'CLOCK.STEPS_AFTER_MINIMUM_PRICE' | translate }}"></dxo-label>
                  <dxi-validation-rule type="required"
                                       message="{{ 'CLOCK.STEPS_AFTER_MINIMUM_PRICE' | translate }} {{ 'SHARED.IS_REQUIRED' | translate }}">
                  </dxi-validation-rule>
                </dxi-item>

                <dxi-item dataField="mode.lowestStopClockPricePercentage" editorType="dxNumberBox" [editorOptions]="{min: 0, max: 100}">
                  <dxo-label text="{{ 'CLOCK.LOWEST_STOP_CLOCK_PRICE_PERCENTAGE' | translate }}"></dxo-label>
                  <dxi-validation-rule type="required"
                                       message="{{ 'CLOCK.LOWEST_STOP_CLOCK_PRICE_VALIDATION' | translate }}">
                  </dxi-validation-rule>
                </dxi-item>
              </dxi-item>

              <dxi-item dataField="mode.startPriceIncrementSteps" editorType="dxNumberBox">
                <dxo-label text="{{ 'CLOCK.START_PRICE_INCREMENT_STEPS' | translate }}"></dxo-label>
              </dxi-item>

              <dxi-item dataField="mode.offsetPriceSteps" editorType="dxNumberBox">
                <dxo-label text="{{ 'CLOCK.OFFSET_PRICE_STEPS' | translate }}"></dxo-label>
              </dxi-item>

              <dxi-item itemType="group" [visible]="(model.mode.mode === 1)">
                <dxi-item dataField="mode.maxRoundSteps" editorType="dxNumberBox">
                  <dxo-label text="{{ 'CLOCK.MAX_ROUND_STEPS' | translate }}"></dxo-label>
                </dxi-item>
              </dxi-item>             

              <dxi-item itemType="group" [visible]="(model.mode.mode === 3 || model.mode.mode === 4)">
                <dxi-item dataField="mode.waitTime" editorType="dxNumberBox">
                  <dxo-label text="{{ 'CLOCK.WAIT_TIME' | translate }}"></dxo-label>
                </dxi-item>

                <dxi-item dataField="mode.minWaitTime" editorType="dxNumberBox">
                  <dxo-label text="{{ 'CLOCK.MIN_WAIT_TIME' | translate }}"></dxo-label>
                </dxi-item>

                <dxi-item dataField="mode.maxWaitTime" editorType="dxNumberBox">
                  <dxo-label text="{{ 'CLOCK.MAX_WAIT_TIME' | translate }}"></dxo-label>
                </dxi-item>

                <dxi-item dataField="mode.waitTimeMinPrice" editorType="dxNumberBox">
                  <dxo-label text="{{ 'CLOCK.WAIT_TIME_MIN_PRICE' | translate }}"></dxo-label>
                </dxi-item>

                <dxi-item dataField="mode.minWaitTimeMinPrice" editorType="dxNumberBox">
                  <dxo-label text="{{ 'CLOCK.MIN_WAIT_TIME_MIN_PRICE' | translate }}"></dxo-label>
                </dxi-item>

                <dxi-item dataField="mode.maxWaitTimeMinPrice" editorType="dxNumberBox">
                  <dxo-label text="{{ 'CLOCK.MAX_WAIT_TIME_MIN_PRICE' | translate }}"></dxo-label>
                </dxi-item>

                <dxi-item dataField="mode.maxDownstepsToAllowRisingClock" editorType="dxNumberBox">
                  <dxo-label text="{{ 'CLOCK.MAX_DOWNSTEPS_TO_ALLOW_RISING_PRICE' | translate }}"></dxo-label>
                </dxi-item>

                <dxi-item dataField="mode.reactivateWaitTime" editorType="dxCheckBox">
                  <dxo-label text="{{ 'CLOCK.REACTIVATE_WAIT_TIME' | translate }}" location="right"></dxo-label>
                </dxi-item>

                <dxi-item dataField="mode.waitTimePurchaseAfterWaitTImeMinPrice" editorType="dxCheckBox">
                  <dxo-label text="{{ 'CLOCK.WAIT_TIME_PURCHASE_AFTER_WAIT_TIME_MIN_PRICE' | translate }}" location="right"></dxo-label>
                </dxi-item>
              </dxi-item>

              <dxi-item itemType="group"
                        [visible]="(model.mode.mode === 2)">
                <dxi-item dataField="mode.lotNumberPrefix" editorType="dxNumberBox">
                  <dxo-label text="{{ 'CLOCK.LOT_NUMBER_PREFIX' | translate }}"></dxo-label>
                </dxi-item>
              </dxi-item>

              <dxi-item itemType="group"
                        [visible]="(model.mode.mode !== 2)" *ngIf="user.isSystemUser">
                <dxi-item dataField="mode.hideClockCircle" editorType="dxCheckBox">
                  <dxo-label text="{{ 'CLOCK.HIDE_CLOCK_CIRCLE' | translate }}" location="right"></dxo-label>
                </dxi-item>
              </dxi-item>

              <dxi-item itemType="group" [visible]="(model.mode.mode !== 1 && model.mode.mode !== 2)">
                <dxi-item dataField="mode.beepOnStartWaitTime" editorType="dxCheckBox">
                  <dxo-label text="{{ 'CLOCK.BEEP_ON_START_WAIT_TIME' | translate }}" location="right"></dxo-label>
                </dxi-item>
              </dxi-item>

              <dxi-item itemType="group" [visible]="(model.mode.mode === 5 || model.mode.mode === 6)">
                <dxi-item dataField="mode.showLastCallPopup" editorType="dxCheckBox">
                  <dxo-label text="{{ 'CLOCK.SHOW_LAST_CALL_POPUP' | translate }}" location="right"></dxo-label>
                </dxi-item>

                <dxi-item dataField="mode.showTemporaryWinnerDelay" editorType="dxNumberBox">
                  <dxo-label text="{{ 'CLOCK.SHOW_TEMPORARY_WINNER_DELAY' | translate }}"></dxo-label>
                </dxi-item>

                <dxi-item dataField="mode.biddingModeIncrementSteps" editorType="dxNumberBox">
                  <dxo-label text="{{ 'Bid increment steps' | translate }}"></dxo-label>
                </dxi-item>

                <dxi-item dataField="mode.waitTimeOnPurchase" editorType="dxNumberBox">
                  <dxo-label text="{{ 'CLOCK.WAIT_TIME_ON_PURCHASE' | translate }}"></dxo-label>
                </dxi-item>
              </dxi-item>
            </dxi-item>

            <dxi-item itemType="group" [visible]="model.mode.mode === 1">
              <dxi-item dataField="mode.useMultiTransaction" editorType="dxCheckBox">
                <dxo-label text="{{ 'CLOCK.USE_MULTI_TRANSACTION' | translate }}"></dxo-label>
              </dxi-item>
              <dxi-item itemType="group" [visible]="model.mode.useMultiTransaction">
                <dxi-item dataField="mode.postScanningTime" editorType="dxNumberBox" [editorOptions]="{min: 0}">
                  <dxo-label text="{{ 'CLOCK.POST_SCANNING_TIME' | translate }}"></dxo-label>
                </dxi-item>
                <dxi-item dataField="mode.validateMaximumNumberOfUsers" editorType="dxNumberBox" [editorOptions]="{min: 1, max: 99}">
                  <dxo-label text="{{ 'CLOCK.VALIDATE_MAXIMUM_NUMBER_OF_USERS' | translate }}"></dxo-label>
                </dxi-item>
                <dxi-item dataField="mode.transactionPriceEqualsTo" editorType="dxSelectBox"
                        [editorOptions]="{ items: transactionPriceEqualsToTypes, valueExpr:'value', displayExpr: translateSelectBoxes }">
                <dxo-label text="{{ 'CLOCK.TRANSACTION_PRICE_EQUALS_TO' | translate }}"></dxo-label>
              </dxi-item>
              <dxi-item dataField="mode.orderingBuyersPriority" editorType="dxSelectBox"
                        [editorOptions]="{ items: orderingBuyersPriorityTypes, valueExpr:'value', displayExpr: translateSelectBoxes }">
                <dxo-label text="{{ 'CLOCK.ORDERING_BUYERS_PRIORITY' | translate }}"></dxo-label>
              </dxi-item>
              </dxi-item>
            </dxi-item>
          </dxi-tab>
          
          <dxi-tab title="{{ 'SHARED.TRANSACTIONS' | translate }}">

            <dxi-item dataField="transactions.showOnlyTransactionsInBuffer" editorType="dxCheckBox">
              <dxo-label text="{{ 'CLOCK.SHOW_ONLY_TRANSACTIONS_IN_BUFFER' | translate }}" location="right"></dxo-label>
            </dxi-item>

            <dxi-item dataField="transactions.visibleTransactions" editorType="dxNumberBox">
              <dxo-label text="{{ 'CLOCK.VISIBLE_TRANSACTIONS' | translate }}"></dxo-label>
            </dxi-item>

            <dxi-item dataField="transactions.buyerMinimumPriceId" editorType="dxSelectBox"
                      [editorOptions]="{ dataSource: buyersPaginated, valueExpr:'buyerId', displayExpr:'name', showClearButton: true, searchEnabled: true }">
              <dxo-label text="{{ 'CLOCK.BUYER_MINIMUM_PRICE' | translate }}"></dxo-label>
              <dxi-validation-rule type="required" message="{{ 'CLOCK.BUYER_MINIMUM_PRICE' | translate }} {{ 'SHARED.IS_REQUIRED' | translate }}">
              </dxi-validation-rule>
            </dxi-item>

            <dxi-item dataField="transactions.buyerNotSoldId" editorType="dxSelectBox"
                      [editorOptions]="{ dataSource: buyersPaginated, valueExpr:'buyerId', displayExpr:'name', showClearButton: true, searchEnabled: true }">
              <dxo-label text="{{ 'CLOCK.BUYER_NOT_SOLD' | translate }}"></dxo-label>
              <dxi-validation-rule type="required" message="{{ 'CLOCK.BUYER_NOT_SOLD' | translate }} {{ 'SHARED.IS_REQUIRED' | translate }}">
              </dxi-validation-rule>
            </dxi-item>

            <dxi-item dataField="transactions.showTransactions" editorType="dxRadioGroup"
                      [editorOptions]="{ items: showTransactionSettings, valueExpr:'value', displayExpr: translateSelectBoxes }">
              <dxo-label text="{{ 'CLOCK.SHOW_TRANSACTIONS' | translate }}"></dxo-label>
            </dxi-item>

            <dxi-item dataField="transactions.transactionInfoMs" editorType="dxNumberBox">
              <dxo-label text="{{ 'CLOCK.CLEAR_TRANSACTION_INFO_AND_USER_DISPLAY_NAME_IN_CLOCK_FACE_AFTER' | translate }}"></dxo-label>
            </dxi-item>

            <dxi-item dataField="transactions.enableTransactionDeleteRequest" editorType="dxCheckBox">
              <dxo-label text="{{ 'CLOCK.ENABLE_TRANSACTION_DELETE_REQUEST' | translate }}" location="right"></dxo-label>
            </dxi-item>

          </dxi-tab>
          <dxi-tab title="{{ 'CLOCK.AUDIO' | translate }}">
            <dxi-item dataField="audio.enableAudio" editorType="dxCheckBox">
              <dxo-label text="{{ 'CLOCK.ENABLE_AUDIO' | translate }}" location="right"></dxo-label>
            </dxi-item>

            <dxi-item itemType="group" [visible]="model.audio.enableAudio">
              <dxi-item dataField="audio.audioAuctioneer" editorType="dxRadioGroup"
                        [editorOptions]="{items: auctioneerAudioSettings, valueExpr:'value', displayExpr: translateSelectBoxes }">
                <dxo-label text="{{ 'CLOCK.AUCTIONEER_AUDIO' | translate }}"></dxo-label>
              </dxi-item>

              <dxi-item dataField="audio.audioBuyer" editorType="dxRadioGroup"
                        [editorOptions]="{items: buyerAudioSettings, valueExpr:'value', displayExpr: translateSelectBoxes }">
                <dxo-label text="{{ 'CLOCK.BUYER_AUDIO' | translate }}"></dxo-label>
              </dxi-item>
              <dxi-item dataField="audio.audioDisconnectType" editorType="dxSelectBox"
                        [editorOptions]="{ items: audioDisconnectTypes, valueExpr:'value', displayExpr: translateSelectBoxes }">
                <dxo-label text="{{ 'CLOCK.AUDIO_DISCONNECT' | translate }}"></dxo-label>
              </dxi-item>
            </dxi-item>
          </dxi-tab>
          <dxi-tab title="{{ 'CLOCK.NETWORK' | translate }}" *ngIf="user.isSystemUser">

            <dxi-item itemType="group" caption="{{ 'CLOCK.NETWORK_LATENCY_TITLE' | translate }}">
              <dxi-item dataField="network.networkLatencyExcellent" editorType="dxNumberBox">
                <dxo-label text="{{ 'CLOCK.NETWORK_LATENCY_EXCELLENT' | translate }}"></dxo-label>
                <dxi-validation-rule type="required"
                                     message="{{ 'CLOCK.NETWORK_LATENCY_TIMEOUT' | translate }} {{ 'SHARED.IS_REQUIRED' | translate }}">
                </dxi-validation-rule>
              </dxi-item>

              <dxi-item dataField="network.networkLatencyAverage" editorType="dxNumberBox">
                <dxo-label text="{{ 'CLOCK.NETWORK_LATENCY_AVERAGE' | translate }}"></dxo-label>
                <dxi-validation-rule type="required"
                                     message="{{ 'CLOCK.NETWORK_LATENCY_TIMEOUT' | translate }} {{ 'SHARED.IS_REQUIRED' | translate }}">
                </dxi-validation-rule>
              </dxi-item>

              <dxi-item dataField="network.networkLatencyPoor" editorType="dxNumberBox">
                <dxo-label text="{{ 'CLOCK.NETWORK_LATENCY_POOR' | translate }}"></dxo-label>
                <dxi-validation-rule type="required"
                                     message="{{ 'CLOCK.NETWORK_LATENCY_TIMEOUT' | translate }} {{ 'SHARED.IS_REQUIRED' | translate }}">
                </dxi-validation-rule>
              </dxi-item>

              <dxi-item dataField="network.networkLatencyTimeout" editorType="dxNumberBox">
                <dxo-label text="{{ 'CLOCK.NETWORK_LATENCY_TIMEOUT' | translate }}"></dxo-label>
                <dxi-validation-rule type="required"
                                     message="{{ 'CLOCK.NETWORK_LATENCY_TIMEOUT' | translate }} {{ 'SHARED.IS_REQUIRED' | translate }}">
                </dxi-validation-rule>
              </dxi-item>
            </dxi-item>


          </dxi-tab>
          <dxi-tab *ngIf="(model.mode.mode === 1)" title="{{ 'CLOCK.RESTART_STEPS' | translate }}">
            <dxi-item itemType="group">
              <dxi-item dataField="mode.restartSteps" editorType="dxNumberBox">
                <dxo-label text="{{ 'CLOCK.RESTART_STEPS' | translate }}"></dxo-label>
                <dxi-validation-rule type="custom"
                                    message="{{ 'CLOCK.RESTART_STEPS_EVEN_NUMBER_VALIDATION' | translate }}"
                                    [validationCallback]="restartStepValidation">
                </dxi-validation-rule>
              </dxi-item>
              <dxi-item dataField="mode.showRestartSteps" editorType="dxCheckBox">
                <dxo-label text="{{ 'CLOCK.SHOW_RESTART_STEPS' | translate }}" location="right"></dxo-label>
              </dxi-item>
              <dxi-item *ngIf="model.mode.showRestartSteps" dataField="mode.restartStepDuration" editorType="dxNumberBox">
                <dxo-label text="{{ 'CLOCK.RESTART_STEP_DURATION' | translate }}"></dxo-label>
              </dxi-item>
            </dxi-item>
          </dxi-tab>
          <dxi-tab title="{{ 'CLOCK.SETTINGS' | translate }}">
            <dxi-item itemType="group">
              <dxi-item dataField="settings.maskDotpositionOnBuyIntention" editorType="dxCheckBox" *ngIf="user.isSystemUser">
                <dxo-label text="{{ 'CLOCK.MASK_DOT_POSITION_ON_BUY_INTENTION' | translate }}" location="right"></dxo-label>
              </dxi-item>

              <dxi-item dataField="settings.ticketPrinter" editorType="dxCheckBox">
                <dxo-label text="{{ 'CLOCK.TICKET_PRINTER' | translate }}" location="right"></dxo-label>
              </dxi-item>

              <dxi-item dataField="settings.creditLimitVerificationActive" editorType="dxCheckBox">
                <dxo-label text="{{ 'CLOCK.CREDIT_LIMIT_VERIFICATION_ACTIVE' | translate }}" location="right"></dxo-label>
              </dxi-item>

              <dxi-item dataField="settings.buyerNumber" editorType="dxCheckBox">
                <dxo-label text="{{ 'SHARED.BUYER_NUMBER' | translate }}" location="right"></dxo-label>
              </dxi-item>

              <dxi-item dataField="settings.productClock" editorType="dxCheckBox">
                <dxo-label text="{{ 'CLOCK.PRODUCT_CLOCK' | translate }}" location="right"></dxo-label>
              </dxi-item>

              <dxi-item dataField="settings.lotsDivisible" editorType="dxCheckBox">
                <dxo-label text="{{ 'CLOCK.LOTS_DIVISIBLE' | translate }}" location="right"></dxo-label>
              </dxi-item>

              <dxi-item dataField="settings.autoValidateBuyerChoice" editorType="dxSelectBox" *ngIf="user.isSystemUser"
                        [editorOptions]="{ items: autoValidateBuyerChoiceTypes, valueExpr:'value', displayExpr: translateSelectBoxes }">
                <dxo-label text="{{ 'CLOCK.AUTO_VALIDATE_BUYER_CHOICE' | translate }}"></dxo-label>
              </dxi-item>              

              <dxi-item dataField="settings.temporaryBlockBuyerAmountOfClockstarts" editorType="dxNumberBox">
                <dxo-label text="{{ 'CLOCK.TEMP_BLOCK_BUYER_AMOUNT_CLOCKSTARTS' | translate }}"></dxo-label>
              </dxi-item>

              <dxi-item dataField="settings.temporaryBlockBuyerResetOnNextlot" editorType="dxCheckBox">
                <dxo-label text="{{ 'CLOCK.TEMP_BLOCK_BUYER_RESET_NEXT_LOT' | translate }}" location="right"></dxo-label>
              </dxi-item>

              <dxi-item dataField="settings.buyerPopupRequestAmount" editorType="dxSelectBox" *ngIf="user.isSystemUser"
                        [editorOptions]="{ items: buyerPopupRequestAmounts, valueExpr:'value', displayExpr: translateSelectBoxes}">
                <dxo-label text="{{ 'CLOCK.BUYER_POPUP_REQUEST_AMOUNT' | translate }}"></dxo-label>
              </dxi-item>

              <dxi-item itemType="group" [visible]="model.settings.autoValidateBuyerChoice">
                <dxi-item dataField="settings.autoValidationDelay" editorType="dxNumberBox">
                  <dxo-label text="{{ 'CLOCK.CURRENT_LOT_UPDATE_DELAY' | translate }}"></dxo-label>
                </dxi-item>
              </dxi-item>

              <dxi-item dataField="settings.visibleNextLots" editorType="dxNumberBox">
                <dxo-label text="{{ 'CLOCK.VISIBLE_NEXT_LOTS' | translate }}"></dxo-label>
                <dxi-validation-rule type="required" message="{{ 'CLOCK.VISIBLE_NEXT_LOTS' | translate }} {{ 'SHARED.IS_REQUIRED' | translate }}">
                </dxi-validation-rule>
              </dxi-item>

              <dxi-item dataField="settings.livePriceIndications" editorType="dxCheckBox">
                <dxo-label text="{{ 'CLOCK.LIVE_PRICE_INDICATIONS' | translate }}" location="right"></dxo-label>
              </dxi-item>

              <dxi-item dataField="settings.autoRestartPartialLot" editorType="dxCheckBox">
                <dxo-label text="{{ 'CLOCK.AUTO_RESTART_PARTIAL_LOT' | translate }}" location="right"></dxo-label>
              </dxi-item>

              <dxi-item dataField="settings.autoRestartEntireLot" editorType="dxCheckBox">
                <dxo-label text="{{ 'CLOCK.AUTO_RESTART_ENTIRE_LOT' | translate }}" location="right"></dxo-label>
              </dxi-item>
 
              <dxi-item itemType="group">
                <dxi-item [visible]="(model.settings.autoRestartPartialLot || model.settings.autoRestartEntireLot)" dataField="settings.autoRestartLotDelay" editorType="dxNumberBox" [editorOptions]="{min: 0}">
                  <dxo-label text="{{ 'CLOCK.AUTO_RESTART_LOT_DELAY' | translate }}"></dxo-label>
                  <dxi-validation-rule type="required"
                                       message="{{ 'CLOCK.AUTO_RESTART_LOT_DELAY_VALIDATION' | translate }}">
                  </dxi-validation-rule>
                </dxi-item>
              </dxi-item>

              <dxi-item dataField="settings.autoRestartMultiBuy" editorType="dxCheckBox">
                <dxo-label text="{{ 'CLOCK.AUTO_RESTART_MULTI_BUY' | translate }}" location="right"></dxo-label>
              </dxi-item>

              <dxi-item dataField="settings.autoRestartAfterSnap" editorType="dxCheckBox">
                <dxo-label text="{{ 'CLOCK.AUTO_RESTART_SNAP' | translate }}" location="right"></dxo-label>
              </dxi-item>
 
              <dxi-item itemType="group">
                <dxi-item [visible]="model.settings.autoRestartAfterSnap" dataField="settings.autoRestartAfterSnapDelay" editorType="dxNumberBox" [editorOptions]="{min: 0}">
                  <dxo-label text="{{ 'CLOCK.AUTO_RESTART_SNAP_DELAY' | translate }}"></dxo-label>
                  <dxi-validation-rule type="required"
                                       message="{{ 'CLOCK.AUTO_RESTART_SNAP_DELAY_VALIDATION' | translate }}">
                  </dxi-validation-rule>
                </dxi-item>
              </dxi-item>

              <dxi-item dataField="settings.requestNextLotNumber" editorType="dxCheckBox" *ngIf="user.isSystemUser">
                <dxo-label text="{{ 'CLOCK.REQUEST_NEXT_LOT_NUMBER' | translate }}" location="right"></dxo-label>
              </dxi-item>

              <dxi-item dataField="settings.filterMatrixByClockmode" editorType="dxCheckBox">
                <dxo-label text="{{ 'CLOCK.FILTER_MATRIX_BY_CLOCKMODE' | translate }}" location="right"></dxo-label>
              </dxi-item>

              <dxi-item dataField="settings.subbuyerValidation" editorType="dxCheckBox" *ngIf="selectedCatalog && selectedCatalog.immediateTransactionMode">
                <dxo-label text="{{ 'CLOCK.SUBBUYER_VALIDATION' | translate }}" location="right"></dxo-label>
              </dxi-item>

              <dxi-item dataField="settings.auctioneerAutoLogout" editorType="dxNumberBox">
                <dxo-label text="{{ 'CLOCK.AUCTIONEER_AUTOLOGOUT' | translate }}"></dxo-label>
              </dxi-item>

              <dxi-item dataField="settings.lotInPreparationAutoDelay" editorType="dxNumberBox">
                <dxo-label text="{{ 'CLOCK.LOT_IN_PREPARATION_AUTO_DELAY' | translate }}"></dxo-label>
              </dxi-item>
            </dxi-item>

            <dxi-item dataField="settings.showMinimumPriceDot" editorType="dxCheckBox">
              <dxo-label text="{{ 'CLOCK.SHOW_MINIMUM_PRICE_DOT' | translate }}" location="right"></dxo-label>
            </dxi-item>

            <dxi-item dataField="settings.startpriceOrRoundBehavior" editorType="dxSelectBox" *ngIf="user.isSystemUser"
                      [editorOptions]="{ items: startpriceOrRoundBehaviorTypes, valueExpr:'value', displayExpr: translateSelectBoxes }">
              <dxo-label text="{{ 'CLOCK.STARTPRICE_OR_ROUND_BEHAVIOUR' | translate }}"></dxo-label>
            </dxi-item>                
            
            <dxi-item dataField="settings.selectLotMode" editorType="dxSelectBox" *ngIf="model.settings.productClock"
                      [editorOptions]="{ items: selectLotModeTypes, valueExpr:'value', displayExpr: translateSelectBoxes }">
              <dxo-label text="{{ 'CLOCK.SELECT_LOT_MODE' | translate }}"></dxo-label>
            </dxi-item>  

            <dxi-item dataField="settings.removeSkippedLotsFromClock" editorType="dxCheckBox" *ngIf="model.settings.productClock">
              <dxo-label text="{{ 'CLOCK.REMOVE_SKIPPED_LOTS_FROM_CLOCK' | translate }}" location="right"></dxo-label>
            </dxi-item>

            <dxi-item dataField="settings.toggleSalesUnitMode" editorType="dxSelectBox"
            [editorOptions]="{ items: toggleSalesUnitTypes, valueExpr:'value', displayExpr: translateSelectBoxes }">
              <dxo-label text="{{ 'CLOCK.TOGGLE_SALES_UNIT' | translate }}"></dxo-label>
            </dxi-item> 

            <dxi-item dataField="settings.toggleSalesUnitModeBuyer" editorType="dxCheckBox">
              <dxo-label text="{{ 'CLOCK.TOGGLE_SALES_UNIT_BUYER' | translate }}" location="right"></dxo-label>
            </dxi-item>

            <dxi-item dataField="settings.showClockMode" editorType="dxCheckBox">
              <dxo-label text="{{ 'CLOCK.SHOW_CLOCK_MODE' | translate }}" location="right"></dxo-label>
            </dxi-item>

            <dxi-item dataField="settings.limitAmountOfClockStopsByAuctioneer" editorType="dxCheckBox">
              <dxo-label text="{{ 'CLOCK.LIMIT_AMOUNT_OF_CLOCK_STOPS_BY_AUCTIONEER' | translate }}"></dxo-label>
            </dxi-item> 

            <dxi-item itemType="group">
              <dxi-item [visible]="model.settings.limitAmountOfClockStopsByAuctioneer" dataField="settings.maxAmountClockStopsByAuctioneer" editorType="dxNumberBox" [editorOptions]="{ min: 1, max: 99 }">
                <dxo-label text="{{ 'CLOCK.MAX_AMOUNT_CLOCK_STOPS_BY_AUCTIONEER' | translate }}"></dxo-label>
              </dxi-item>
            </dxi-item>           

          </dxi-tab>
          <dxi-tab title="{{ 'CLOCK.PAUSE_MESSAGES' | translate }}">
            <dx-data-grid #dataGrid [rtlEnabled]="rtlEnabled" [(dataSource)]="pauseMessages"
                          [showBorders]="true"
                          [allowColumnReordering]="false"
                          [hoverStateEnabled]="true"
                          [columnAutoWidth]="true"
                          [rowAlternationEnabled]="true">
              <dxi-column dataField="message" caption="{{ 'CLOCK.PAUSE_MESSAGES' | translate }}">
                <dxi-validation-rule type="required" message="{{ 'CLOCK.PAUSE_MESSAGE' | translate }} {{ 'SHARED.IS_REQUIRED' | translate }}">
                </dxi-validation-rule>
              </dxi-column>
              <dxo-selection mode="single"></dxo-selection>
              <dxo-editing mode="cell" [allowUpdating]="true" [allowAdding]="true" [allowDeleting]="true"
                           [useIcons]="true">
              </dxo-editing>
              <dxo-pager [showPageSizeSelector]="true" [allowedPageSizes]="[5, 10, 20, 30, 40, 50, 100, 200]"
                         [showNavigationButtons]="true">
              </dxo-pager>
            </dx-data-grid>
          </dxi-tab>

          <dxi-tab title="{{ 'CLOCK.VIDEO' | translate }}" *ngIf="videoTabVisible">
            <dxi-item dataField="video.videoURL" editorType="dxTextBox">
              <dxo-label text="{{ 'CLOCK.VIDEO_URL' | translate }}"></dxo-label>
            </dxi-item>

            <dxi-item dataField="video.videoProtocol" editorType="dxSelectBox"
                      [editorOptions]="{ items: videoProtocol, valueExpr:'value', displayExpr:'name'}">
              <dxo-label text="{{ 'CLOCK.VIDEO_PROTOCOL' | translate }}"></dxo-label>
            </dxi-item>            
          </dxi-tab>
        </dxi-item>
      </dx-form>
      <div class="au-dx-popup-padder">
        <button type="submit" class="btn btn-primary" (click)="onSubmit();" name="btnClockSubmit"
              disabled="disabled">
        {{ 'SHARED.SAVE' | translate }}
      </button>
      <button type="button" class="btn btn-outline" (click)="onCancel();">{{ 'SHARED.CANCEL' | translate }}</button>
        </div>
    </dx-scroll-view>
  </dx-popup>
</div>
<save-confirmation-component #saveConfirmation title="{{ 'SHARED.LEAVE_PAGE' | translate }}" buttonCloseText="{{ 'SHARED.OK' | translate }}"
                             cancellable="true" (close)="onCancel();"></save-confirmation-component>
<pause-message-component #pauseMessageDetails></pause-message-component>
